"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styleTypes = require("./styleTypes");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  componentName: "smartHeader",
  cms: {
    style: {
      background: "Header background",
      navColor: "Nav color",
      navHoverColor: "Hover color",
      navFont: "Font size",
      textTransform: "Text transform",
      fontWeight: "Font weight",
      titleFontSize: "Title font size",
      bottomSpace: "Title bottom space",
      contentSpace: "Content bottom space",
      buttonColor: "Button color",
      buttonFontSize: "Font size",
      borderColor: "Color",
      buttonHoverColor: "Hover color",
      borderHoverColor: "Hover color",
      buttonRadius: "Shape"
    },
    links: {
      link1: "Link 1",
      // url1: "Url",
      link2: "Link 2",
      // url2: "Url",
      link3: "Link 3",
      // url3: "Url ",
      buttonTitle: "Button Title",
      buttonUrl: "Button url"
    },
    content: {
      title: "Title",
      content: "Content",
      buttonTitle: "Link title"
    },
    media: {
      logo: "Logo url",
      logoAlt: "Brand image alt",
      bgImage: "Cover image"
    }
  },
  styleType: {
    style: {
      background: { type: "color" },
      navColor: { type: "color" },
      navHoverColor: { type: "color" },
      navFont: _extends({}, _styleTypes.navFontSize),
      textTransform: _extends({}, _styleTypes.linkTextTransform),
      fontWeight: _extends({}, _styleTypes.linkFontWeight),
      titleFontSize: _extends({}, _styleTypes.navFontSize),
      bottomSpace: _extends({}, _styleTypes.navFontSize),
      contentSpace: _extends({}, _styleTypes.navFontSize),
      buttonColor: { type: "color" },
      buttonFontSize: _extends({}, _styleTypes.navFontSize),
      borderColor: { type: "color" },
      buttonHoverColor: { type: "color" },
      borderHoverColor: { type: "color" },
      buttonRadius: _extends({}, _styleTypes.radius)
    },
    content: {
      title: "Title",
      content: "Content",
      buttonTitle: "Link title"
    },
    media: {
      logo: "Logo url",
      logoAlt: "Logo alt text *",
      bgImage: "Cover image"
    }
  },
  props: _defineProperty({
    //editable part
    style: {
      background: "",
      navFont: "16px",
      navColor: "#fff",
      navHoverColor: "#000",
      textTransform: "capitalize",
      fontWeight: "500",
      titleFontSize: "30px",
      bottomSpace: "20px",
      contentSpace: "20px",
      buttonColor: "#fff",
      buttonFontSize: "16px",
      borderColor: "#fff",
      buttonHoverColor: "#000",
      borderHoverColor: "#000",
      buttonRadius: "5px"
    },
    links: {
      link1: "Home",
      // url1: "",
      link2: "enterprise",
      // url2: "",
      link3: "pricing",
      // url3: "",
      buttonTitle: "Learn more",
      buttonUrl: ""
    },
    content: {
      title: "<span>What is Lorem Ipsum</span>",
      content: "<span>What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing\n      and typesetting industry Lorem Ipsum has been the industry's\n      standard dummy text ever since the</span>"
    },
    media: {
      logo: "https://elitemarketingpro.com/go/wp-content/uploads/2016/10/Dummy-logo-white.png",
      logoAlt: "logo",
      bgImage: "https://ik.imagekit.io/marketcube/platform/storybook/header-bg.jpg"
    }
  }, "media", {
    logo: "https://elitemarketingpro.com/go/wp-content/uploads/2016/10/Dummy-logo-white.png",
    logoAlt: "logo",
    bgImage: "https://ik.imagekit.io/marketcube/platform/storybook/header-bg.jpg"
  })
};